import React from 'react'
import { Link } from 'gatsby'
import { Subtitle } from 'bloomerjs'
import logo from '../images/avo-vietnam-logo.png'

const Logo = ({ imgClassName, hideSubtle, textLeft }) => (
  <Link
    to="/"
    style={{
      textDecoration: 'none',
    }}
  >
    <img src={logo} alt="FilipinoAvo" className={imgClassName} />
    {!hideSubtle && <Subtitle isSize='6' className='has-text-right'>Dating App</Subtitle> }
  </Link>
)

export default Logo
